import { createAction } from '@reduxjs/toolkit';
import { initialValue } from '../../helperContext';
import { BaselineAffectationType, PossiblesBaselineAffectationActions } from '../../BaselineAffectationReducers';

export const openEditDrawerAction = createAction(BaselineAffectationType.OpenEditDrawer);

export const closeEditDrawerAction = createAction(BaselineAffectationType.CloseEditDrawer);

export default (state = initialValue, action: PossiblesBaselineAffectationActions) => {
  switch (action.type) {
    case BaselineAffectationType.OpenEditDrawer:
      return {
        ...state,
        isEditDrawerOpen: true,
      };
    case BaselineAffectationType.CloseEditDrawer:
      return {
        ...state,
        isEditDrawerOpen: false,
      };
    default:
      return state;
  }
};
